export const ADD_NEW_RECIPE = 'ADD_NEW_RECIPE';
export const EDIT_RECIPE = 'EDIT_RECIPE';
export const DELETE_RECIPE = 'DELETE_RECIPE';



// WEBPACK FOOTER //
// ./src/actions/types.js